import { languageOptions } from '../../../lang/constants.tsx';

import languageSelectHtml from './languageSelectComponent.html';

class LanguageSelectCtrl {
  constructor($localStorage, $window, gettextCatalog) {
    'ngInject';

    Object.assign(this, { $localStorage, $window, gettextCatalog });
  }

  $onInit() {
    this.languageOptions = languageOptions;
  }
}

export default {
  controllerAs: 'ctrl',
  controller: LanguageSelectCtrl,
  templateUrl: languageSelectHtml,
  bindings: {
    language: '=',
  },
};
